import * as React from 'react';
import {  UIComponentState } from '../uicomponent';
import { DropDownListComponentProps } from './dropdownlistcomponent';
import { DropDownListCSSStyle } from './dropdownlistcss';
import { VerticalListViewImpl } from '../verticallist/verticallistview';

export class DropDownListViewImpl<T> extends VerticalListViewImpl<T>
{
    bindHandlers()
    {

    }

    draw(props: DropDownListComponentProps<T>, state: UIComponentState, cssStyle: DropDownListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        
        return (
            <table  style={props.cssStyle.getWrapperCSSStyle()}>
                <tbody style={{width: "100%", height: "100%", display: "flex", flexFlow: "row wrap"}}>
                {
                    props.listViewModel.getListOfDatas().map((entry, index)=>
                    {
                         return props.listViewModel.getView(entry, index);
                    }
                )
                }
                </tbody>
            </table>    
               
        );
    }

  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownlistview.tsx